import { HttpHandler } from 'msw'

import { consume } from './consume'
import { getStats } from './getStats'

export const general: HttpHandler[] = [consume, getStats]
